/**
 * 带提示框的switch开关
 * zhanghengh 18/07/15
 */

import React, { Component } from 'react';
import TableSwitch from '../TableSwitch';
import Popconfirm from '../Popconfirm';
import { isFunction } from '@platform/api';
import { getMultiLang } from '@platform/api';

require('./index.less');

export default class PopconfirmSwitch extends Component {
    constructor(props) {
        super(props);
        const { checked, onPopconfirmCont = '', offPopconfirmCont = '' } = props;
        this.state = {
            onPopconfirmCont, //打开按钮时弹出框提示内容
            offPopconfirmCont, //关闭按钮时弹出框提示内容
            onFlag: checked,
            json: {},
        };
    }

    UNSAFE_componentWillMount() {
        let callback = (json, bool) => {
            if (bool) {
                this.setState({ json }, () => {
                    // console.log('多语加载完成')
                });
            }
        };
        getMultiLang({ moduleId: 'base_popConfirmSwitch', callback });
    }

    // tips
    UNSAFE_componentWillReceiveProps(nextProps) {
        if ('onPopconfirmCont' in nextProps) {
            if (nextProps.onPopconfirmCont !== this.state.onPopconfirmCont) {
                this.setState({ onPopconfirmCont: nextProps.onPopconfirmCont });
            }
        }
        if ('offPopconfirmCont' in nextProps) {
            if (nextProps.offPopconfirmCont !== this.state.offPopconfirmCont) {
                this.setState({ offPopconfirmCont: nextProps.offPopconfirmCont });
            }
        }
    }

    /**
     *  气泡弹窗确定回调
     */
    onClose = () => {
        const { onChange, checked, onSwitchBefore } = this.props;
        //this.closeFlag = false;
        if (isFunction(onSwitchBefore)) {
            const isContinue = onSwitchBefore();
            const type = this.testType(isContinue);
            const hanlder = () => {
                onChange(!checked); //在这里监控switch的onchnge事件
            };

            switch (type) {
                // true/flase
                case 'Boolean':
                    this.hanlderModelBeforeEvent(true, isContinue, null, hanlder);
                    break;
                // 返回的是async函数
                case 'AsyncFunction':
                    this.hanlderModelBeforeEvent(false, isContinue, false, hanlder);
                    break;
                // 返回的Promise对象
                case 'Promise':
                    this.hanlderModelBeforeEvent(false, isContinue, true, hanlder);
                    break;
                // 取Boolean值
                default:
                    this.hanlderModelBeforeEvent(true, !!isContinue, null, hanlder);
                    break;
            }
            return false;
        }
        onChange(!checked); //在这里监控switch的onchnge事件
    };
    //shouldComponentUpdate(nextProps,nextState){
    //return this.props.value ===nextProps.value;
    //}

    /**
     * 开关状态改变之前回调返回值，统一处理函数
     */
    hanlderModelBeforeEvent = (isBoolean, isContinue, isPromise, hanlder) => {
        if (isBoolean && isContinue) {
            hanlder();
        } else if (!isBoolean) {
            const dist = isPromise ? isContinue : isContinue();
            dist.then(data => {
                !!data && hanlder();
            });
        }
    };

    /**
     * 检测类型
     */
    testType = origin => {
        return Object.prototype.toString.call(origin).slice(8, -1);
    };

    render() {
        const { onPopconfirmCont, offPopconfirmCont, json, onFlag } = this.state;
        const { disabled } = this.props;
        const content = onFlag ? (
            onPopconfirmCont || json['base-popConfirmSwitch-0001']
        ) : (
            offPopconfirmCont || json['base-popConfirmSwitch-0002']
        );
        // const domContent = (
        //     <span>
        //         <span className="iconfont icon-tixing" /> &nbsp;
        //         {content}
        //     </span>
        // );
        return (<Popconfirm
            trigger="click"
            placement="top"
            content={content}
            onClose={this.onClose}
            ref={Popconfirm => (this.confirm = Popconfirm)}
        >
            <span
                onClickCapture={e => {
                    if (disabled) {
                        e.stopPropagation();
                    }
                }}
            >
                <TableSwitch
                    {...this.props}
                    onChange={val => {
                        this.setState({ onFlag: val });
                    }}
                    onKeyDown={() => {
                        // 增加 按键事件  用于快捷键触发  bbqin
                        let confirm = this.confirm;
                        confirm && confirm.Popconfirm && confirm.Popconfirm.show();
                    }}
                />
            </span>
        </Popconfirm>
        );
    }
}
